class SimpleLogger {
    constructor(private category: string) {}

    private formatTime(): string {
        const now = new Date();
        return now.toLocaleTimeString('en-US', { hour12: false }) + '.' + now.getMilliseconds().toString().padStart(3, '0');
    }

    private colorize(level: string): string {
        const colors: { [key: string]: string } = {
            'INF': '\x1b[34m', // Blue
            'WRN': '\x1b[33m', // Yellow
            'ERR': '\x1b[31m', // Red
            'RESET': '\x1b[0m' // Reset
        };
        return `${colors[level]}${level}${colors['RESET']}`;
    }

    private getCallerFunctionName(): string {
        const error = new Error();
        const stack = error.stack?.split('\n');
        if (stack && stack.length > 3) {
            const callerLine = stack[3];
            const match = callerLine.match(/at\s+(?:\S+\.)?(\S+)\s+\(/);
            if (match) {
                return match[1];
            }
        }
        return 'unknown';
    }

    log(...args: any[]) {
        const formattedTime = this.formatTime();
        const coloredLevel = this.colorize('INF');
        const functionName = this.getCallerFunctionName();
        console.log(`${formattedTime} ${coloredLevel} ${this.category}::${functionName}`, ...args);
    }

    warn(...args: any[]) {
        const formattedTime = this.formatTime();
        const coloredLevel = this.colorize('WRN');
        const functionName = this.getCallerFunctionName();
        console.warn(`${formattedTime} ${coloredLevel} ${this.category}::${functionName}`, ...args);
    }

    error(message: string, ...args: any[]) {
        const formattedTime = this.formatTime();
        const coloredLevel = this.colorize('ERR');
        const functionName = this.getCallerFunctionName();
        console.error(`${formattedTime} ${coloredLevel} ${this.category}::${functionName} ${message}`, ...args);
    }
}

export function createLogger(category: string) {
    return new SimpleLogger(category);
}

export type Logger = SimpleLogger;